module.exports = __webpack_public_path__ + "static/media/home_back_mobile.bdb028c5.svg";